import { render, staticRenderFns } from "./drag-table3.vue?vue&type=template&id=221c83ee"
import script from "./drag-table3.vue?vue&type=script&lang=js"
export * from "./drag-table3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports